export const config = {
	footer: {
		elevation: 3,
		color: '#fff',
		minHeight: '40px'
	},
	goTopBtn: {
		small: true,
		icon: true,
		color: 'primary'
	}
};
